import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'server/types/ServerPageInterface'
import { migrateCommand } from '../utils/migrateCommand'
import { migratePhysicalProduct } from './migratePhysicalProduct'

export default function (page: ServerPage): [ServerPage, boolean] {
  return migrateCommand({
    page,
    structureType: structureTypes.PHYSICAL_PRODUCT,
    migrateFunction: migratePhysicalProduct,
  })
}
